import _classCallCheck from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import { Map } from 'immutable';
import React from 'react';
import tabbable from 'tabbable';
import { Divider } from '../Divider';
import { Header } from '../Header';
import { Icon } from '../Icon';
import { Text } from '../Text';
import { filterLimitWarningDataAttribute } from './DataAttributes';
import { FilterDate } from './FilterDate';
import { FilterNumber } from './FilterNumber';
import { FilterText } from './FilterText';
import { filterLimit, FilterTextMulti } from './FilterTextMulti';
import { FilterYear } from './FilterYear';
import { SettingsButton } from './SettingsButton';
import { SortOptions } from './SortOptions';
import styles from './styles.scss';
import { ColumnTypes } from './types';
var locale = {
  warningHeader: 'Unable to add any new filters',
  warningBody: "This report has met its max of ".concat(filterLimit, " filters. Remove a filter to add another.")
};

function calculateOffset(element) {
  var rect = element.getBoundingClientRect();
  return {
    top: 50,
    left: Number(rect.left) - 120
  };
}

export var FilterRenderer = /*#__PURE__*/function (_React$Component) {
  _inherits(FilterRenderer, _React$Component);

  var _super = _createSuper(FilterRenderer);

  function FilterRenderer(props) {
    var _this;

    _classCallCheck(this, FilterRenderer);

    _this = _super.call(this, props);

    _this.handleClick = function (e) {
      if (_this.node && _this.node.current && _this.node.current.contains(e.target)) {
        return;
      }

      _this.props.onClose();
    };

    _this.getFilterComponent = function (type, isMultiText) {
      switch (type) {
        case ColumnTypes.Text:
          return isMultiText ? FilterTextMulti : FilterText;

        case ColumnTypes.Percent:
        case ColumnTypes.Period:
        case ColumnTypes.Currency:
        case ColumnTypes.Number:
          return FilterNumber;

        case ColumnTypes.Year:
          return FilterYear;

        case ColumnTypes.Date:
          return FilterDate;

        default:
          return null;
      }
    };

    _this.getSortText = function (type) {
      switch (type) {
        case ColumnTypes.Text:
          return {
            asc: 'A → Z',
            desc: 'Z → A'
          };

        case ColumnTypes.Percent:
        case ColumnTypes.Period:
        case ColumnTypes.Currency:
        case ColumnTypes.Number:
          return {
            asc: '1 → 9',
            desc: '9 → 1'
          };

        case ColumnTypes.Year:
        case ColumnTypes.Date:
          return {
            asc: 'Oldest → Newest',
            desc: 'Newest → Oldest'
          };

        default:
          return null;
      }
    };

    _this.handleShowSettings = function () {
      return _this.props.onShowSettings();
    };

    _this.handleSortAsc = function () {
      _this.props.onSortAsc(_this.props.columnName);

      _this.focusActiveColumnButtonAndClose();
    };

    _this.handleSortDesc = function () {
      _this.props.onSortDesc(_this.props.columnName);

      _this.focusActiveColumnButtonAndClose();
    };

    _this.handleClearSort = function () {
      _this.props.onClearSort();

      _this.focusActiveColumnButtonAndClose();
    };

    _this.handleApplyFilter = function (state) {
      _this.props.onApplyFilter(_this.props.columnName, state);

      _this.focusActiveColumnButtonAndClose();
    };

    _this.handleClearFilter = function () {
      _this.props.onClearFilter(_this.props.columnName);

      _this.focusActiveColumnButtonAndClose();
    };

    _this.handleSearchFilter = function (searchQuery) {
      return _this.props.getFilterOptions ? _this.props.getFilterOptions(searchQuery) : Map();
    };

    _this.focusActiveColumnButtonAndClose = function () {
      if (_this.props.activeColumnDiv) {
        var headerButton = _this.props.activeColumnDiv.querySelector('button');

        if (headerButton && headerButton.focus) {
          headerButton.focus();
        }
      }

      _this.props.onClose();
    };

    _this.handleKeyDown = function (event) {
      if (event.key === 'Escape') {
        _this.focusActiveColumnButtonAndClose();
      } else if (event.key === 'Tab') {
        var focusableElements = tabbable(_this.node.current);

        if (focusableElements && focusableElements.length) {
          if (event.shiftKey) {
            if (document.activeElement.isEqualNode(focusableElements[0])) {
              event.preventDefault();

              _this.focusActiveColumnButtonAndClose();
            }
          } else {
            if (document.activeElement.isEqualNode(focusableElements[focusableElements.length - 1])) {
              event.preventDefault();

              _this.focusActiveColumnButtonAndClose();
            }
          }
        }
      }
    };

    _this.node = React.createRef();
    var style = null;

    if (props.activeColumnDiv) {
      var _calculateOffset = calculateOffset(props.activeColumnDiv),
          top = _calculateOffset.top,
          left = _calculateOffset.left;

      style = {
        top: top,
        left: left
      };
    }

    _this.state = {
      style: style
    };
    return _this;
  }

  _createClass(FilterRenderer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      document.addEventListener('mousedown', this.handleClick);

      if (this.node && this.node.current) {
        this.node.current.focus(); // const focusableElements = tabbable(this.node.current);
        // if (focusableElements && focusableElements.length) {
        //   focusableElements[0].focus();
        // }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener('mousedown', this.handleClick);
    }
  }, {
    key: "render",
    value: function render() {
      var FilterComponent = null;
      var _this$props = this.props,
          columnType = _this$props.columnType,
          getFilterState = _this$props.getFilterState,
          columnName = _this$props.columnName,
          _this$props$showSetti = _this$props.showSettingsButton,
          showSettingsButton = _this$props$showSetti === void 0 ? true : _this$props$showSetti,
          filterCount = _this$props.filterCount,
          isMultiText = _this$props.isMultiText;
      var sortText = this.getSortText(columnType);

      if (columnType) {
        FilterComponent = this.getFilterComponent(columnType, isMultiText);
      }

      if (!this.props.activeColumnDiv) {
        return null;
      }

      var filterLimitReached = filterCount >= filterLimit;
      return React.createElement("div", {
        tabIndex: 0,
        role: "menu",
        ref: this.node,
        style: this.state.style,
        className: styles.filterPositioner,
        onKeyDown: this.handleKeyDown
      }, React.createElement("div", {
        className: styles.sortLabelContainer
      }, React.createElement(Header, {
        variant: "h5"
      }, "Sort")), sortText && React.createElement(SortOptions, {
        ascText: sortText.asc,
        descText: sortText.desc,
        onClearSort: this.handleClearSort,
        onSortAsc: this.handleSortAsc,
        onSortDesc: this.handleSortDesc,
        sortActive: columnName === this.props.sortColumn,
        sortDirection: this.props.sortDirection
      }), React.createElement(Divider, null), React.createElement("div", {
        className: styles.filterContainer
      }, React.createElement("div", {
        className: styles.labelContainer
      }, React.createElement(Header, {
        variant: "h5"
      }, "Filter")), filterLimitReached && React.createElement("div", {
        className: styles.limitWarning,
        "data-test": filterLimitWarningDataAttribute
      }, React.createElement("div", {
        className: styles.limitWarningIcon
      }, React.createElement(Icon, {
        icon: "status-warning"
      })), React.createElement("div", {
        className: styles.limitWarningMessage
      }, React.createElement(Header, {
        variant: "h5",
        className: styles.limitHeader
      }, React.createElement("div", {
        className: styles.limitHeader
      }, locale.warningHeader)), React.createElement(Text, {
        size: "minimum",
        font: "condensed",
        color: "light"
      }, locale.warningBody))), FilterComponent && React.createElement(FilterComponent, {
        filterState: getFilterState(columnName),
        onClearFilter: this.handleClearFilter,
        onApplyFilter: this.handleApplyFilter,
        filtersDisabled: filterLimitReached,
        getFilterOptions: this.handleSearchFilter
      })), showSettingsButton && React.createElement(SettingsButton, {
        onClick: this.handleShowSettings
      }));
    }
  }]);

  return FilterRenderer;
}(React.Component);